// src/components/bot/ContactsTab.jsx
import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Alert,
  AlertIcon,
  Spinner,
  Center
} from '@chakra-ui/react';
import RubricaManager from '../rubrica/RubricaManager';

const ContactsTab = ({ bot, onUpdate, contacts, loading = false }) => {
  if (loading) {
    return (
      <Center py={8}>
        <VStack spacing={4}>
          <Spinner size="lg" color="blue.500" />
          <Text color="gray.500">Loading contacts...</Text>
        </VStack>
      </Center>
    );
  }

  if (!bot) {
    return (
      <Alert status="warning">
        <AlertIcon />
        No bot selected
      </Alert>
    );
  }

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="lg" mb={2}>
            Contacts
          </Heading>
          <Text color="gray.600">
            Manage contacts for {bot.name}. These contacts will be available to your bot for personalized interactions.
          </Text>
        </Box>

        <RubricaManager 
          bot={bot} 
          onUpdate={onUpdate}
          
        />
      </VStack>
    </Box>
  );
};

export default ContactsTab;